<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  isMobileSidebarOpen: { type: Boolean, default: false },
});

const emit = defineEmits(['toggle']);

const route = useRoute();

// An open conversation has its own back button, and the launcher would cover
// the reply box
const isConversationOpen = computed(() => !!route.params.conversation_id);
</script>

<template>
  <div
    v-if="!isConversationOpen && !isMobileSidebarOpen"
    id="mobile-sidebar-launcher"
    class="fixed bottom-4 ltr:left-4 rtl:right-4 z-20 md:hidden"
  >
    <div class="rounded-full bg-n-alpha-2 p-1">
      <Button
        icon="i-lucide-menu"
        class="!rounded-full !bg-n-solid-3 dark:!bg-n-alpha-2 !text-n-slate-12 text-xl"
        lg
        @click="emit('toggle')"
      />
    </div>
  </div>
  <template v-else />
</template>
